export function normalizeYesNo(val: string): 'Yes' | 'No' | undefined {
  if (typeof val === 'string') {
    const lower = val.trim().toLowerCase();
    if (lower === 'yes') return 'Yes';
    if (lower === 'no') return 'No';
  }
  return undefined;
}
